// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-rise -> weidner-apartment-homes-rise-rise -> swan-creek
// Generated: 2026-10-27T17:12:00.607Z
// Counts: 0 design, 27 content, 7 slot group, 1 collection binding, 9 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover a vibrant lifestyle at Swan Creek Apartment Homes in Fitchburg, WI. Here, modern living meets the spirit of the Swan Creek neighborhood in Nine Springs. Picture your morning strolls to Swan Creek Park or a bike ride down the Capital City trail. With Agora at Fitchburg Center nearby, a world of local shopping, flavor, and community events awaits. Flexible layouts and thoughtfully designed features let you make the most of every day in this inviting hub.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentcafe-chatbot.background_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "VALUE",
    "customValue": "<p>Swan Creek blends convenience and style, offering a warm, active community to come home to. From in-home laundry to controlled building access and additional storage options, your routine gets a welcome upgrade. Take advantage of a fitness center, grilling gazebo, and direct access to walking trails - all designed for connection and comfort in Fitchburg's Swan Creek of Nine Springs neighborhood.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=48/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.inject_dni_classes": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments In <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>LOVE WHERE YOU LIVE</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Swan Creek in Fitchburg, you get a true balance of in-home comforts and community extras. Step inside your apartment and discover a full-size washer and dryer, energy-efficient appliances, and tall nine-foot ceilings. Step outside to take advantage of our fitness center, grilling gazebo, and direct access to local walking trails - all within a pet-friendly, controlled-access building. Additional storage and a variety of parking options make life simple.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Reach out to Swan Creek's leasing team in Fitchburg, WI. Whether you have questions about floor plans, want to schedule a tour, or are ready for your next home, we're here to help every step of the way.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Looking for apartments for rent in Fitchburg, WI, with options that fit your routine? Swan Creek offers studios, one-, and two-bedroom floor plans designed for both busy mornings and relaxing nights. Enjoy extras like in-home laundry, energy-efficient appliances, and valuable storage options. Whether you work from home or want more breathing room, you'll find a layout that feels just right.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get a closer look at life at Swan Creek. Explore images of roomy living spaces, bright kitchens, and the comfort waiting for you in every apartment home. From the welcoming courtyard to open layouts perfect for relaxing or entertaining, see the spaces that set Swan Creek apart in Fitchburg, WI.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Join a lively and connected neighborhood at Swan Creek Apartment Homes in Fitchburg, WI. Nestled near the green stretch of Swan Creek Park and the scenic Capital City bike trail, you'll be close to fresh air and the buzz of Agora at Fitchburg Center. Local shops, flavorful dining, and seasonal community events invite you to step out and enjoy everything Fitchburg has to offer. Whether it's biking to parks, picking up groceries, or finding a new favorite coffee spot, life here means more walkable moments and less time in the car.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Pets – Max 2 Allowed. Monthly Pet Rent: $40 per pet. Refundable Pet Deposit: $350 per pet. Cats &amp; Dogs are welcome! No weight limit.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Pit Bull &amp; Pit Bull Mixes&nbsp;</p></li><li><p>American Pit Bull Terrier&nbsp;</p></li><li><p>American Staffordshire Terrier&nbsp;</p></li><li><p>Wolf Hybrids&nbsp;</p></li><li><p>Doberman Pinscher&nbsp;</p></li><li><p>Saint Bernard&nbsp;</p></li><li><p>American Bulldog&nbsp;</p></li><li><p>Staffordshire Bull Terrier&nbsp;</p></li><li><p>Rottweiler&nbsp;</p></li><li><p>German Shepherd&nbsp;</p></li><li><p>Chow Chow&nbsp;</p></li><li><p>Great Dane&nbsp;</p></li><li><p>Akita</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to step inside your next apartment? Schedule a tour of Swan Creek in Fitchburg, WI, and choose how you want to explore. Prefer a personal touch? Our team is happy to offer guided tours. If you want to explore at your own pace, try a self-guided or virtual tour - all options are available by appointment. We're here to help you picture life at Swan Creek, whether it's from your sofa or on-site. Touring restrictions may apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel2_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Everyday Comforts, All Around You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Want to see what life is like at Swan Creek Apartment Homes before you visit? Our virtual tour lets you wander through modern layouts and welcoming community spaces, all from wherever you are. Picture yourself cooking in the open kitchen or unwinding in your own living area - every detail is ready for you to explore. Start planning your next move in Fitchburg today.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.address": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_google_business_url"
      }
    }
  },
  "footer.love_notes_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d44f3-3412-75a9-9aac-8f5678cb59df.webp"
      }
    }
  },
  "footer.weidner_cares_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d44f3-3452-767e-8966-83b6939f057f.webp"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": 10,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.apartmentPhotos": {
    "limit": 21,
    "hiddenIds": [
      "custom_a93068f0-0878-4d23-912c-f1a66a769f79",
      "custom_51ac7e4a-8097-46b7-9738-ee7cdf0206d4",
      "custom_3d6818f2-857e-4654-ba02-4bb8e1fa5631"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      4,
      12,
      13
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 10
    }
  ]
};

export const styleOverrides = {};
